import {Component, OnInit, TemplateRef, ViewChild, viewChild} from '@angular/core';
import {FooterComponent} from '../../footer/footer.component';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {HeaderComponent} from '../../header/header.component';
import {MatCardModule} from '@angular/material/card';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {NgForOf, NgIf} from '@angular/common';
import {OrganisationService} from '../../../shared/services/organisation.service';
import {GlobalService} from '../../../shared/services/global.service';
import {PaymentService} from '../../../shared/services/payment.service';
import {ActivatedRoute, Router} from '@angular/router';
import {AlertService} from '../../../shared/services/alert.service';
import {AuthService} from '../../../shared/services/auth.service';
import {MatButton} from "@angular/material/button";
import {MatDialog, MatDialogContent, MatDialogTitle} from "@angular/material/dialog";
import {MatOption} from "@angular/material/autocomplete";
import {MatSelect} from "@angular/material/select";
import {SharedModule} from "../../../shared/shared.module";
import {AppConstants} from "../../../shared/constants/app-constant";
import {CountryService} from "../../../shared/services/country.service";
import {StateService} from "../../../shared/services/state.service";
import {Helper} from "../../../shared/constants/helper";

@Component({
  selector: 'vex-check-out',
  standalone: true,
  imports: [
    FooterComponent,
    FormsModule,
    HeaderComponent,
    MatCardModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatSlideToggleModule,
    NgForOf,
    ReactiveFormsModule,
    NgIf,
    MatButton,
    MatDialogContent,
    MatDialogTitle,
    MatOption,
    MatSelect,
    SharedModule
  ],
  templateUrl: './check-out.component.html',
  styleUrl: './check-out.component.scss',
  providers: [GlobalService, OrganisationService, AlertService, PaymentService, AuthService, CountryService, StateService]
})
export class CheckOutComponent implements OnInit {
  @ViewChild('updateBillingInformationModal') updateBillingInformationModal: TemplateRef<any>;
  defaultCountry: any = AppConstants.DEFAULT_COUNTRY;

  planDetail: any;
  submitted: boolean
  Id: any;
  checkoutForm: FormGroup = new FormGroup({});
  user: any;
  self: any;
  countries: any
  states: any
  pageExtras: any = {
    'submitted': false,
    'buttonText': 'Next',
    'currentIndex': 0,
    'selectedCountry': false,
    'buttonStatus': true
  };

  constructor(private formBuilder: FormBuilder,
              private organisationService: OrganisationService,
              private route: ActivatedRoute,
              private alertService: AlertService,
              private router: Router,
              private paymentService: PaymentService,
              private authService: AuthService,
              protected dialog: MatDialog,
              private countryService: CountryService,
              private stateService: StateService,
  ) {
    this.authService.self().subscribe(data => {
      if (data && data.id) {
        this.user = data;
        this.getPlan();
      }
    })
    this.route.params.subscribe(data => {
      if (data && data['id']) {
        this.Id = data['id'];
      }
    });
    this.setPatchValue()
  }

  ngOnInit() {
    this.refresh();
  }

  refresh() {
    this.checkoutForm = this.formBuilder.group({
      'organisation_name': ['', Validators.required],
      'name': ['', Validators.required],
      'email': ['', Validators.required],
      'contact': ['', Validators.required],
      'username': ['', Validators.required],
      'gst_number': [''],
      'pan_number': [''],
      'address': ['', Validators.required],
      'country_id': ['', Validators.required],
      'state_id': [''],
      'foreign_state_name': [''],
      'city': ['', Validators.required],
      'zip_code': ['', Validators.required],
    });
  }

  setPatchValue() {
    this.getCountries()
  }

  openUpdateBillingInformationModal(): void {
    this.checkoutForm.patchValue({
      'organisation_name': (this.user && this.user.organisation_name) ? this.user.organisation_name : '',
      'name': (this.user && this.user.name) ? this.user.name : '',
      'email': (this.user && this.user.email) ? this.user.email : '',
      'contact': (this.user && this.user.contact) ? this.user.contact : '',
      'username': (this.user && this.user.username) ? this.user.username : '',
      'gst_number': (this.user && this.user.gst_number) ? this.user.gst_number : '',
      'pan_number': (this.user && this.user.pan_number) ? this.user.pan_number : '',
    });
    this.dialog.open(this.updateBillingInformationModal, {
      width: '50vw',
      minWidth: '350px'
    });
    this.getCountries()
  }

  getPlan() {
    this.organisationService.planDetail(this.Id).subscribe(data => {
      if (data) {
        this.planDetail = data;
        this.planDetail['start_date'] = this.user?.current_date;
        this.planDetail['start_time'] = this.user?.current_time;
        this.planDetail['expiry_date'] = Helper.addDaysWithDate(this.user?.current_date, parseInt(this.planDetail?.duration));
        let activeCoupon: any;
        if (this.planDetail && this.planDetail['coupon'] && this.planDetail['coupon'].length > 0) {
          this.planDetail['coupon'].forEach(coupon => {
            if (coupon && coupon['status'] === 'ACTIVE') {
              activeCoupon = coupon;
            }
          });
        }
        if (activeCoupon) {
          this.planDetail['discounted_price'] = parseFloat(this.planDetail['price']) - parseFloat(activeCoupon['discount_amount']);
          this.planDetail['active_coupon'] = activeCoupon;
        }
        this.planDetail['gst'] = this.planDetail['discounted_price'] ? (this.planDetail['discounted_price'] * 18 / 100) : '-';
      }
    });
  }

  getCountries(): void {
    this.countryService.get().subscribe(data => {
      if (data && data['data'].length > 0) {
        this.countries = data['data'];
      }
    });
    this.checkoutForm.patchValue({
      country_id: (this.user && this.user['country_id']) ? this.user['country_id'] : '',
      city: (this.user && this.user['city']) ? this.user['city'] : '',
      zip_code: (this.user && this.user['zip_code']) ? this.user['zip_code'] : '',
      address: (this.user && this.user['address']) ? this.user['address'] : '',
      gst_number: (this.user && this.user['gst_number']) ? this.user['gst_number'] : '',
      pan_number: (this.user && this.user['pan_number']) ? this.user['pan_number'] : '',
    });
    this.getStates()

  }

  getStates(): void {
    let country = (this.checkoutForm.value && this.checkoutForm.value['country_id']) ? this.checkoutForm.value['country_id'] : '';
    if (country == AppConstants.DEFAULT_COUNTRY.id) {
      this.stateService.get().subscribe(data => {
        if (data && data['data'].length > 0) {
          this.states = data['data'];
          this.checkoutForm.patchValue({
            state_id: (this.user && this.user['state_id']) ? this.user['state_id'] : ''
          });
        }
      });
    }
  }

  updateBillingInformation(): void {
    this.pageExtras['submitted'] = true;
    const params: {} = {
      organisation_name: (this.checkoutForm && this.checkoutForm.getRawValue() && this.checkoutForm.getRawValue().organisation_name ? this.checkoutForm.getRawValue().organisation_name : ''),
      name: (this.checkoutForm && this.checkoutForm.getRawValue() && this.checkoutForm.getRawValue().name ? this.checkoutForm.getRawValue().name : ''),
      email: (this.checkoutForm && this.checkoutForm.getRawValue() && this.checkoutForm.getRawValue().email ? this.checkoutForm.getRawValue().email : ''),
      contact: (this.checkoutForm && this.checkoutForm.getRawValue() && this.checkoutForm.getRawValue().contact ? this.checkoutForm.getRawValue().contact : ''),
      username: (this.checkoutForm && this.checkoutForm.getRawValue() && this.checkoutForm.getRawValue().username ? this.checkoutForm.getRawValue().username : ''),
      gst_number: (this.checkoutForm && this.checkoutForm.getRawValue() && this.checkoutForm.getRawValue().gst_number ? this.checkoutForm.getRawValue().gst_number : ''),
      pan_number: (this.checkoutForm && this.checkoutForm.getRawValue() && this.checkoutForm.getRawValue().pan_number ? this.checkoutForm.getRawValue().pan_number : ''),
      address: (this.checkoutForm && this.checkoutForm.getRawValue() && this.checkoutForm.getRawValue().address ? this.checkoutForm.getRawValue().address : ''),
      zip_code: (this.checkoutForm && this.checkoutForm.getRawValue() && this.checkoutForm.getRawValue().zip_code ? this.checkoutForm.getRawValue().zip_code : ''),
      city: (this.checkoutForm && this.checkoutForm.getRawValue() && this.checkoutForm.getRawValue().city ? this.checkoutForm.getRawValue().city : ''),
      country_id: (this.checkoutForm && this.checkoutForm.getRawValue() && this.checkoutForm.getRawValue().country_id ? this.checkoutForm.getRawValue().country_id : ''),
      state_id: (this.checkoutForm && this.checkoutForm.getRawValue() && this.checkoutForm.getRawValue().state_id ? this.checkoutForm.getRawValue().state_id : ''),
      foreign_state_name: (this.checkoutForm && this.checkoutForm.getRawValue() && this.checkoutForm.getRawValue().foreign_state_name ? this.checkoutForm.getRawValue().foreign_state_name : ''),
    }
    this.authService.billingInformation(params).subscribe(data => {
      this.dialog.closeAll()
    });

  }


  paymentInitiated(planId: any) {
    const user = localStorage.getItem('self');
    if (!user) {
      this.alertService.showErrors('At first, please login, then try to purchase a plan!');
      this.router.navigateByUrl('/add-org');
      return;
    }
    let params = {};
    if (this.planDetail && this.planDetail['active_coupon'] && this.planDetail['active_coupon']['id']) {
      params = {
        'plan_id': planId,
        'coupon_id': this.planDetail['active_coupon']['id']
      };
    } else {
      params = {
        'plan_id': planId,
      };
    }
    this.paymentService.initiatePayment(params).subscribe(response => {
      if (response && response.url) {
        window.location.href = response.url;
      } else {
        console.error('Invalid response from server', response);
      }
    });
  }

  redirectToCCAvenue(response: any) {
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = response.url;

    const encRequest = document.createElement('input');
    encRequest.type = 'hidden';
    encRequest.name = 'encRequest';
    encRequest.value = response.encRequest;
    form.appendChild(encRequest);

    const accessCode = document.createElement('input');
    accessCode.type = 'hidden';
    accessCode.name = 'access_code';
    accessCode.value = response.access_code;
    form.appendChild(accessCode);

    document.body.appendChild(form);
    form.submit();
  }

  goto(url: any): void {
    this.router.navigateByUrl(url);
  }

  protected readonly Number = Number;
  protected readonly console = console;
}
